import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import React, { Component } from "react";
import TopBar from "../components/pages/layout/TopBar";
import Users from "../components/pages/users/Users"
import Application from "../components/pages/application/Application";
import MasterData from "../components/pages/masterdata/MasterData";
import axios from "axios";
import { UserNotFound } from "../components/pages/userNotFound";
import { SessionExpired } from "../components/pages/sessionExpired";
import { CookiesProvider } from "react-cookie";

class Routing extends Component {

  componentDidMount() {
    const userDetails = localStorage.getItem("userData");
    let userToken = JSON.parse(userDetails);
    if (userToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${userToken.id_token}`;
    }
  }

  componentWillMount() {
    axios.interceptors.request.use(
      (config) => {
        const userDetails = localStorage.getItem("userData");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.id_token;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  render() {
    return (
      <>
        {(window.location.pathname == "/usernotfound" || window.location.pathname == "/sessionexpired") ? "" :
          <TopBar />}
        <CookiesProvider>
        <Routes>
          <Route exact path="/" element={<Navigate to={"/users"} />} />
          <Route path="/users" element={<Users />} />
          <Route element={<Outlet />}>
            <Route path="/application" element={<Application />} />
            <Route path="/divisioncode" element={<MasterData key={1} />} />
            <Route path="/departmentcode" element={<MasterData key={2} />} />
            <Route path="/categorycode" element={<MasterData key={3} />} />
            <Route path="/level" element={<MasterData key={4} />} />
            <Route path="/designation" element={<MasterData key={5} />} />
            <Route path="/mainrole" element={<MasterData key={6} />} />
            <Route path="/supportingrole" element={<MasterData key={7} />} />
          </Route>
          <Route path="/usernotfound" element={<UserNotFound />} />
          <Route path="/sessionexpired" element={<SessionExpired />} />
        </Routes>
        </CookiesProvider>
      </>
    );
  }
}

export default Routing;
